export default __webpack_public_path__ + "static/media/people.42c0e28a.svg";